import React, { Fragment, useState } from 'react';
import Navbar from '../../components/Navbar';
import { Grid } from 'jrgrid';
import { pagePurchaseOrders } from './api';
import { poColumns } from './utils';
import { Button, Col, Row } from 'react-bootstrap';

export const PurchaseOrders = (props: any) => {
  const [refresh, setRefresh] = useState<boolean>(true)
  const [columns, setColumns] = useState(poColumns)

const rowColor = (status: string) => {
  switch (status) {
    case 'Approved':
      return '#b6d7a8';
    case 'Pending':
      return '#fff2cc';
    case 'Rejected':
      return '#f4cccc';
    default:
      return null;
  }
};

  const grid = () => {
    if(refresh){
      setTimeout(() => {
        setRefresh(false)
      }, 500);
    }else{
      let filter = []

      return(
        <Grid
        amount={18}
        columns={columns}
        query={pagePurchaseOrders}
        queryName='pagePurchaseOrders'
        rowStyle={(rowInfo) => {return {
          style: {
            background: rowColor(rowInfo.row.status)
          }
        }}}        
        defaultSortField='id'
        globalFilters={[...filter]}
        csv
        />
      )
    }
  }

  return (
    <Fragment>
      <Navbar />
      <Row>
        <Col md={8}>
          <h1 className='m-2'>Purchase Orders</h1>
        </Col>
        <Col md={4}>
        <Button href='/purchaseOrders/create' className='float-right m-2' variant='info'>
          Request Purchase Order
        </Button>
        </Col>
      </Row>
      <div className='ml-2 mr-2'>{grid()}</div>
    </Fragment>
  );
};
